import BaseViewController from '../../common/services/base-view-controller';

class FeasibilityController extends  BaseViewController {

    constructor($scope, $state, $rootScope,  LoadedModel) {
        super($scope, $state, LoadedModel);
        this._$rootScope = $rootScope;

        let view = this.getCurrentView();

        const meshView =  this.model.getView(this.meshViewKey);

        $scope.$on('formingTypeChanged', () => {
            this.checkAndSendModel();
        });

        const sendSolverRequest = () => {
            setTimeout(() => {
                this.sendModel();
            }, 0);
        };

        if(view) {
            this.loadCurrentView();
        } else if(meshView) {
            this.loadView(meshView, this.meshViewKey);
            if (this.model.passedSteps.indexOf('feasibility') === -1) {
                sendSolverRequest();
            }
        } else if (this.model.isStepPassed('part')) {
            this.loadViewByType();
        } else {
            this._$state.go('home');
        }
    }

    getSelectedKey() {
        return this.model.results === 'thinning' ? this.thinningViewKey : this.feasibilityViewKey;
    }

    getViewKey() {
        return this.model.results === 'thinning' ? this.thinningViewKey : this.feasibilityViewKey;
    }

    getCurrentView() {
        return this.model.getView(this.getSelectedKey());
    }

    loadCurrentView() {
        const view  = this.getCurrentView();
        this.model.setCashedView(view);
        const key = this.getSelectedKey();
        this.loadView(view, key);
    }

    loadViewByType() {
        const formingType = this.model.results;
        const data = formingType === 'thinning' ? this.model.getThinningData() : this.model.getFormabilityData();
        this.updateCurrentView([data, this.model.maxDimensions], formingType);
    }

    invalidateBlankData() {
      const invalidateDataMapper = [
        'blankBoundaryModCustom',
        'showWidthInput',
        'isUsedCustomWidth',
        'customWidth',
        'nestN3',
        'nestN2',
        'nestView'
      ];
      invalidateDataMapper.forEach((key) => {
        this.model[key] = undefined;
      });
    }

    checkAndSendModel() {
        const cashedModel = this.model.getCashed();
        if (cashedModel) {
            this.model.passedSteps = ["part", "feasibility"];
            this._$rootScope.$broadcast('updateSteps', {step: "feasibility"});
            this.model.updateSim(cashedModel);
            const view = this.model.getCashedSimView();
            const key = this.getSelectedKey();
            this.invalidateBlankData();
            this.model.invalidateSnapshots('feasibility');
            // this.model.invalidateStep('feasibility');
            this.model[key] = view;
            this.loadViewByData(this.model.getViewData(key), key);
            this.model.calculateUtilizationInfo();
        } else {
            this.sendModel();
        }
    }

    sendModel() {
        this.requestInProgress = this.model.requestInProgress = true;
        const uniqParam = this.model.uuid();
        this.model.getProgress(uniqParam, 'feasibility', true);
        this.model.sendData('feasibility', false, uniqParam).then((results) => {
            this.model.generateExpTime();
            this.requestInProgress = this.model.requestInProgress = false;
            this.model.passedSteps = results.passedSteps;
            this.model.invalidateSnapshots('feasibility');
            this.invalidateBlankData();
            const simData = {
                afeb: results.afeb,
                blankBoundaryMod: results.blankBoundaryMod,
                mex: results.mex,
                boundary: results.boundary,
                meshLL: results.meshLL
            };

            this.model.updateSimAndCash(this.model.holdingCond, simData);
            this.model.calculateUtilizationInfo();
            this.loadViewByType();
            this._$scope.$broadcast('solverFinished', {step: 'feasibility'});
        }, () => {
            this._$rootScope.$broadcast('showErrorDialog', {type: 'feasibility'});
            this.model.generateExpTime();
            this.requestInProgress = this.model.requestInProgress = false;
        });
    }
}

FeasibilityController.$inject = ['$scope', '$state', '$rootScope', 'LoadedModel'];

export default FeasibilityController;



// WEBPACK FOOTER //
// ./client/app/components/feasibility/feasibility.controller.js